import { selectGameUrl } from '../game-utils';

function appendGameUrl(orderItems) {
  return orderItems.map((oi) => ({
    url: selectGameUrl(window.location.origin, oi.game),
    ...oi,
  }));
}

export { appendGameUrl };
